/**
 * Хук данных «Лента заявок» менеджеру.
 *
 * Бэк: GET /v1/admin/requests (manager/owner допущены через
 * RequirePlatformAdminWithRoleExceptionPrefixes в cmd/api/main.go).
 * Server-state только через React Query; фильтр по состоянию.
 */
import { useQuery } from '@tanstack/react-query';
import { listManagerRequests } from '@hsc/api-client';
import type { ManagerRequestsFilters, ManagerRequestsResponse } from '@hsc/types';

export function useManagerRequests(filters?: ManagerRequestsFilters) {
  return useQuery<ManagerRequestsResponse>({
    queryKey: ['requests', 'admin', filters ?? {}],
    queryFn: () => listManagerRequests(filters),
    staleTime: 15_000,
  });
}
